export const application = 'bright-local';

export const apiURL = 'http://localhost:5200/bright/api';

export const gaId = '';

export const academyURL = 'http://localhost:3003';

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
